import { render, staticRenderFns } from "./Hospital.vue?vue&type=template&id=6bce5534&scoped=true"
import script from "./Hospital.vue?vue&type=script&lang=js"
export * from "./Hospital.vue?vue&type=script&lang=js"
import style0 from "./Hospital.vue?vue&type=style&index=0&id=6bce5534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce5534",
  null
  
)

export default component.exports